export default __webpack_public_path__ + "45aa36d763c5efb36f4e715bac086d61.svg";